import React, { useRef } from "react";
import CoupleSection2 from "../../components/CoupleSection2/CoupleSection2";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import VenueSection from "../../components/VenueSection/VenueSection";
import InviteeSection from "../../components/InviteeSection/InviteeSection";
import EventSection4 from "../../components/EventSection4/EventSection4";
import QuoteSection from "../../components/QuoteSection/QuoteSection";
import WeddingDate from "../../components/WeddingDate/WeddingDate";
import HeroIndian from "../../components/heroIndian/heroIndian";
import CoupleIndian from "../../components/CoupleIndian/CoupleIndian";
import BottomSection from "../../components/BottomContainer/BottomContainer";
import RsvpSectionS2 from "../../components/RsvpSectionS2/RsvpSectionS2";
import LetterEnvelope from "../../components/LetterEnvelope/LetterEnvelope";

const IndianTouch = () => {
  const containerRef = useRef(null);
  return (
    <div
      ref={containerRef}
      className={`fadeInSlow scroll-container hero-indian`}
    >
      <div className="section">
        <HeroIndian />
        {/* <WeddingDate /> */}
      </div>
      <CoupleIndian />
      <LetterEnvelope />

      <QuoteSection />
      <EventSection4 haveBackground={true} />
      <VenueSection />
      <RsvpSectionS2 />
      <InviteeSection haveBackground={true} />
      {/* <StorySection2 /> */}
      {/* <PortfolioSection /> */}
      {/* <RsvpSection /> */}
      {/* <RsvpSectionS3 bg={bg} /> */}
      {/* <BlogSection /> */}
      <BottomSection />
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </div>
  );
};

export default IndianTouch;
